import { useGLTF } from '@react-three/drei'
import React, { useRef } from 'react';
import { useFrame } from '@react-three/fiber';


export function Barcelona (props) {
  const { nodes, materials } = useGLTF('/models/fc_barcelona-leo.glb')
  const groupRef = useRef();
  useFrame(() => {
    if (groupRef.current) {
      groupRef.current.rotation.y += 0.025; 
    }
  });

  return (
    <group ref={groupRef} {...props} dispose={null}>
      <group rotation={[-Math.PI / 2, 0, 0]} scale={0.002}>
        <group rotation={[Math.PI / 2, 0, 0]}>
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.defaultMaterial.geometry}
            material={materials.PolyUnwrapperCheckerMaterial}
            rotation={[-Math.PI / 2, 0, 0]}
          />
        </group>
      </group>
    </group>
  )
}

useGLTF.preload('/models/fc_barcelona-leo.glb')
